var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_268_3100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.584 14.625C27.584 15.3633 26.9688 15.9375 26.2715 15.9375H24.959L25 22.5C25 22.623 25 22.7461 25 22.8281V23.4844C25 24.4277 24.2617 25.125 23.3594 25.125H22.7031C22.6211 25.125 22.5801 25.125 22.5391 25.125C22.498 25.125 22.416 25.125 22.375 25.125H21.0625H20.0781C19.1348 25.125 18.4375 24.4277 18.4375 23.4844V22.5V19.875C18.4375 19.1777 17.8223 18.5625 17.125 18.5625H14.5C13.7617 18.5625 13.1875 19.1777 13.1875 19.875V22.5V23.4844C13.1875 24.4277 12.4492 25.125 11.5469 25.125H10.5625H9.25C9.16797 25.125 9.12695 25.125 9.04492 25.125C9.00391 25.125 8.96289 25.125 8.92188 25.125H8.26562C7.32227 25.125 6.625 24.4277 6.625 23.4844V18.8906C6.625 18.8906 6.625 18.8496 6.625 18.8086V15.9375H5.3125C4.57422 15.9375 4 15.3633 4 14.625C4 14.2559 4.12305 13.9277 4.41016 13.6406L14.9102 4.45312C15.1973 4.16602 15.5254 4.125 15.8125 4.125C16.0996 4.125 16.4277 4.20703 16.6738 4.41211L27.1328 13.6406C27.4609 13.9277 27.625 14.2559 27.584 14.625Z",
    fillOpacity: 0.6,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_268_3100",
    x: 0,
    y: 0.125,
    width: 31.625,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_268_3100"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_268_3100",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/HOME.dd4fe9aa26fa1f7ba84f302360f2e587.svg";
export { ForwardRef as ReactComponent };